export const getInputClasses = (hasError = false, otherClassNames = "") =>
  hasError
    ? `py-3 border-2 rounded-2xl border-red outline-pw-red px-6 bg-gray-100 ${otherClassNames}`
    : `py-3 border-2 rounded-2xl outline-pw-blue px-6 bg-gray-100 ${otherClassNames}`;

export const getServerError = (e) => {
  if (e?.response?.data?.error) {
    const error = e?.response?.data?.error;
    if (typeof error === "string") {
      return error;
    }
    if (Array.isArray(error)) {
      let msg = "";
      error.forEach((err) => {
        msg += err + "\n";
      });
      return msg;
    }
  }
  return "There was an error";
};

export const formatAmount = (amount) =>
  new Intl.NumberFormat("en-US").format(amount);

export const routes = {
  home: "/",
  buy_water: "/buy-water",
  transactions: "/transactions",
  report_leakage: "/report-leakage",
  login: "/login",
  about: "/about",
  contact: "/contact",
  signup: "/signup",
  pay: "/buy-water/pay",
  receipt: "/transactions/:tx_ref/receipt",
  forgot_password: "/forgot-password",
  forgot_password_success: "/forgot-password/next",
  privacy_policy: "/privacy-policy",
  data_deletion: "/data-deletion",
  manage_meters: "/manage-meters",
};

export const toLitres = (cubicMetres) => {
  if (typeof cubicMetres === "string") {
    cubicMetres = Number(cubicMetres);
  }
  const value = cubicMetres * 1000;
  return formatAmount(value);
};

export const convertAmountToCubicMetres = (waterPrice, amount) => {
  return waterPrice ? Number((amount / waterPrice).toFixed(2)) : 0;
};
